/**
 * The one list of values `attendeeRegistrations.registrationState` may hold.
 *
 * The column is varchar(64) (see drizzle/pg-core-compat.ts), so this list is
 * enforced in the database only by `attendee_registrations_state_check` in
 * drizzle-pg/0028_special_event_approval.sql. Adding a value means changing
 * both, in a new migration.
 */
export const ATTENDEE_REGISTRATION_STATES = [
  "registered",
  "waitlisted",
  "cancelled",
  "rejected",
  "external_checkout_started",
  "payment_processing_unavailable",
  "payment_pending",
  "payment_failed",
  "pending_review",
] as const;

export type AttendeeRegistrationState = (typeof ATTENDEE_REGISTRATION_STATES)[number];

/** stateChangeReason written by an admin decline (pending_review → waitlisted). */
export const ADMIN_DECLINE_REASON = "admin_decline";

/** Only a confirmed registration may see or receive an event's join URL. */
export const JOIN_URL_STATES = ["registered"] as const satisfies readonly AttendeeRegistrationState[];

const REGISTRATION_STATE_LABELS: Record<AttendeeRegistrationState, string> = {
  registered: "Registered",
  waitlisted: "Waitlisted",
  cancelled: "Cancelled",
  // Legacy value with no writer; the special-event flow declines to `waitlisted` instead.
  rejected: "Rejected",
  external_checkout_started: "Checkout started",
  payment_processing_unavailable: "Payment unavailable",
  payment_pending: "Payment pending",
  payment_failed: "Payment failed",
  pending_review: "Under review",
};

export function registrationStateLabel(state: string): string {
  return (REGISTRATION_STATE_LABELS as Record<string, string>)[state]
    ?? state.replaceAll("_", " ").replace(/\b\w/g, letter => letter.toUpperCase());
}
